import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Play, Square, Pause, Clock, Mic, Loader2 } from "lucide-react";

export default function NoterControlPanel({
  status,
  duration,
  segmentCount,
  onStart,
  onStop,
  onPause,
  onResume,
  loading = false,
}) {
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-100 bg-gradient-to-r from-emerald-50 to-white">
        <Mic className="w-4 h-4 text-emerald-500" />
        <h3 className="text-sm font-semibold text-slate-700">Noter Controls</h3>
      </div>
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1.5">
              <Clock className="w-4 h-4 text-slate-400" />
              <span className="text-lg font-mono font-bold text-slate-700">
                {formatTime(duration)}
              </span>
            </div>
            <Badge variant="outline" className={status === "active" ? "bg-green-50 text-green-700 border-green-200" : "bg-slate-50 text-slate-500"}>
              {status === "active" ? "LIVE" : status === "paused" ? "PAUSED" : status === "completed" ? "ENDED" : "IDLE"}
            </Badge>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {(status === "idle" || status === "completed") && (
            <Button onClick={onStart} disabled={loading} className="bg-emerald-600 hover:bg-emerald-700 text-white">
              {loading ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Play className="w-4 h-4 mr-1" />}
              {loading ? "Starting..." : "Start"}
            </Button>
          )}
          {status === "active" && (
            <>
              <Button onClick={onPause} variant="outline" className="border-amber-300 text-amber-700 hover:bg-amber-50">
                <Pause className="w-4 h-4 mr-1" />
                Pause
              </Button>
              <Button onClick={onStop} variant="destructive" className="bg-red-600 hover:bg-red-700">
                <Square className="w-4 h-4 mr-1" />
                Stop
              </Button>
            </>
          )}
          {status === "paused" && (
            <>
              <Button onClick={onResume} className="bg-emerald-600 hover:bg-emerald-700 text-white">
                <Play className="w-4 h-4 mr-1" />
                Resume
              </Button>
              <Button onClick={onStop} variant="destructive" className="bg-red-600 hover:bg-red-700">
                <Square className="w-4 h-4 mr-1" />
                Stop
              </Button>
            </>
          )}
        </div>

        {segmentCount > 0 && (
          <div className="mt-3 text-[10px] text-slate-400">
            {segmentCount} segments captured
          </div>
        )}
      </div>
    </div>
  );
}
